import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { Link as MuiLink } from '@mui/material';
import { styled } from '@mui/material/styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const ContactSection = styled(Box)({
  padding: '50px 0px 20px 0',
  backgroundColor: '#f5f5f5'
});


const ContactGrid = styled(Grid)({
  // maxWidth: '1200px',
  margin: '0 auto'
});

const ContactItem = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  padding: '20px',
  '& .MuiSvgIcon-root': {
    fontSize: '40px',
    marginBottom: '15px',
    color: '#333'
  }
});


const Contact = () => {
  return (
    <>
      <ContactSection component="section">
        <div style={{ overflow: "hidden" }}>
          <Typography
            variant="h4"
            fontWeight="bold"
            textAlign="center"
            gutterBottom
            color="rgba(26,128,200)"

          >
            Contact US
          </Typography>
          <ContactGrid container >
            <Grid item xs={12} md={4}>
              <ContactItem>
                <LocationOnIcon />
                <Typography>
                  <a
                    href="https://www.google.com/maps/place/2201+Murfreesboro+Pike,+Suite+D-110,+Nashville,+TN+37217"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#333', textDecoration: 'none' }}
                  >
                    2201 Murfreesboro Pike, Suite D-110<br />
                    Nashville, TN 37217<br />
                    British Woods Business Center
                  </a>
                </Typography>
              </ContactItem>
            </Grid>
            <Grid item xs={12} md={4}>
              <ContactItem>
                <EmailIcon />
                <Typography>
                <MuiLink
                  href="hamsalomi2014@gmail.com"
                  underline="none"
                  sx={{
                    color: '#333', // Default color (for all screens)
                    '@media (min-width: 1200px)': { // For large screens (xl breakpoint)
                      color: '#333', // Force color to black on large screens
                    },
                  }}
                >
                 hamsalomi2014@gmail.com
                </MuiLink>
            </Typography>
              </ContactItem>
            </Grid>
            <Grid item xs={12} md={4}>
              <ContactItem>
                <PhoneIcon />
                <Typography>
                  <MuiLink
                    href="tel:6293189355"
                    underline="none"
                    sx={{
                      color: '#333', // Default color (for all screens)
                      '@media (min-width: 1200px)': { // For large screens (xl breakpoint)
                        color: '#333', // Force color to black on large screens
                      },
                    }}
                  >
                    6157569963
                  </MuiLink>
                </Typography>
              </ContactItem>
            </Grid>
          </ContactGrid>
        </div>
      </ContactSection>

      
    </>
  );
};

export default Contact; 